import media from "./media";
import React, { useState } from "react";
import { useNavigate } from "react-router";



function LibrarySplash(props) {

    const [filteredBy, setFilteredBy] = useState("featured");
    let navigate = useNavigate();


    const listMedia = media.filter(item => (item.type.includes(props.pageName)) == true).map(temp =>
        <div className="media-item" onClick={() => navigate(`/library/${temp.id}`)}>
          <img src={temp.thumbnail}></img>
          <div className="media-hover">
            <h3 className="hover-title">{temp.title}</h3>

            {(temp.tags != undefined) ? 
            <div className="hover-tags">
              {temp.tags.map((tag, index) =>
              <p>{tag}{(index < temp.tags.length - 1) ? "," : ""}</p>                    
              )}
            </div>
            : ""}

          </div>
        </div>
    );

    const handleMediaSelection = (temp) =>{
      props.setSelectedMedia(temp);
      props.setMediaSelected(true);
    }

    return (
       <div className= {'info-subpage-wrapper'}> 
         {/* MY INFO SUMMARY */}
         <div id="library-positioner" className="about-me">
          <div id="library-featured">
            <div className="title">
              <h2>{props.pageName}</h2>
            </div>
            <div id="featured-items">
              {listMedia}
            </div>
          </div>

{(props.pageName != "Featured") ? "" :
          <div id="library-description">
            <p>Welcome to my free media library!</p>
            <br/>
            <p>This a collection of things I enjoyed that meet the following criteria: </p>
            <br></br>
            <p>✃  Freely available by methods which are not too complicated.</p>
            <p>✃  I liked it.</p>
            <br></br>
            <p>Click an item for more information. Hover (or press and hold on mobile?) to see the title & tags.</p>
            <p>The library is still a work in progress. Filters coming soon!</p>

          </div>
}
         
          {/* <div id="library-disclaimer">
            <p>DISCLAIMER: </p>
             <br></br>
             <p>I do not support piracy. Please do not recommend that I add piracy resources like the <a href="https://www.reddit.com/r/Piracy/wiki/megathread/">r/Piracy masterlist</a> or its mirror on <a href="https://rentry.co/megathread">Rentry.</a> These contain instructions for how to easily pirate media. We should all be supporting our favorite media through official streaming services, 
             no matter how easy it is to stream things illegally from our phones using sites like Cineby.</p>
           </div> */}
          </div>
          
           </div>
    );
  }

  export default LibrarySplash;